/**
 * Search Bar Vue Component
 * ------------------------------------------------------------------------------
 * Template in snippets/search-bar.liquid
 * 
 */

import Vue from 'vue';
import axios from 'axios';
import debounce from 'lodash-es/debounce';

Vue.component('search-bar', {
    props: [
        'defaultValue'
    ],

    data() {
        return {
            isSearchLoading: false,
            isSearchOpen: false,
            search: null,
            results: []
        }
    },

    watch: { // Debounce and watchers - https://vuejs.org/v2/guide/computed.html#Watchers
        search(newValue, oldValue) {
            if (newValue) {
                this.isSearchOpen = true;
                this.debouncedPerformSearch();
            } else if (oldValue) {
                this.closeSearch();
                this.results = [];
            }
        }
    },

    created() {
        this.search = this.defaultValue;
        this.debouncedPerformSearch = debounce(this.performSearch, 500);

        setTimeout(() => { // Don't show on load on search page
            this.isSearchOpen = false;
        }, 100);
    },

    methods: {
        closeSearch() {
            this.isSearchOpen = false;
            document.querySelector('[search-bar-form-wrapper] input').focus();
        },

        handleSearchIconClicked(e) {
            if (!this.search) {
                e.preventDefault();
                e.target.closest('.search-form').querySelector('input[name="q"]').focus();
            }
        },

        performSearch() {
            if (this.search.length) {
                this.isSearchLoading = true;

                axios.get(`/search/suggest.json?s=${this.search}&resources[types][]=product&resources[limit]=4&resources[unavailable_products]=bury`).then((response) => {
                    this.results = response.data.resources.results.products;

                    if (this.results.length) {
                        setTimeout(() => {
                            let element = document.querySelector('[dropdown-form-wrapper] input');
                            if (element) element.focus();
                        }, 100);

                    } else {
                        this.closeSearch();
                    }
    
                }).catch((error) => {
                    console.log(error);
    
                }).finally(() => {
                    this.isSearchLoading = false;
                });
            }
        }
    } 
});